module.exports = __webpack_public_path__ + "media/readok.b57be67d.mp3";